import { BaseDto } from './base.dto';
import { PurchaseOrderDto } from './purchaseOrder.dto';
import { PurchaseOrderStatusDto } from './purchaseOrderStatus.dto';
import { UserDto } from './user.dto';

export class PurchaseOrderStatusHistoryDto extends BaseDto {
  note: string;
  purchaseOrderId: number;
  purchaseOrderStatusOldId?: number;
  purchaseOrderStatusId: number;
  purchaseOrder?: PurchaseOrderDto;
  purchaseOrderStatus?: PurchaseOrderStatusDto;
  purchaseOrderStatusOld?: PurchaseOrderStatusDto;
  lastModifiedUser?: UserDto;
}